// Ctrl/Cmd+clique deve abrir em nova aba (padrão do navegador), em vez de navegar na aba atual —
// usado nos pontos de listagem que já não são um <a href> real (linha de tabela, card do Kanban).
export function navegarComCtrl(navigate, caminho, event) {
    if (event?.ctrlKey || event?.metaKey) {
        window.open(caminho, "_blank", "noopener,noreferrer");
        return;
    }
    navigate(caminho);
}
